import {
    Component,
    EventEmitter,
    Input,
    Output,
    ChangeDetectionStrategy,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';

@Component({
    selector: 'app-submit-to-ewa-form-submission',
    templateUrl: './submit-to-ewa-form-submission.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatCardModule, MatButtonModule],
})
export class SubmitToEwaFormSubmissionComponent {
    @Input() disableSubmission: boolean = false;
    @Input() submitButtonLabel: string = 'Submit to EWA';
    @Input() showDisclaimer: boolean = true;
    @Output() submitForm = new EventEmitter<void>();

    handleSubmit(): void {
        this.submitForm.emit();
    }
}
